import makeStyles from '@material-ui/core/styles/makeStyles';
import { SnackbarProvider } from 'notistack';
import { Suspense, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { loadI18n } from './app/i18n';
import store from './app/store';
import './assets/css/index.scss';
import Loading from './components/Loading';
import * as serviceWorkerRegistration from './serviceWorker';

const useStyles = makeStyles(
  () => ({
    root: {
      zIndex: 7000,
    },
    containerAnchorOriginTopLeft: {
      left: 24,
    },
  }),
  {
    name: 'SnackbarRoot',
  },
);

function Index() {
  const classes = useStyles();
  const [languageReady, setLanguageReady] = useState(false);

  const initI18n = async () => {
    await loadI18n();
    setLanguageReady(true);
  };

  useEffect(() => {
    initI18n();
  }, []);

  return languageReady ? (
    <Suspense fallback={<Loading />}>
      <Provider store={store}>
        <Router>
          <SnackbarProvider
            classes={{
              containerRoot: classes.root,
              containerAnchorOriginTopLeft:
                classes.containerAnchorOriginTopLeft,
            }}
            maxSnack={5}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <App />
          </SnackbarProvider>
        </Router>
      </Provider>
    </Suspense>
  ) : (
    <Loading />
  );
}

ReactDOM.render(<Index />, document.getElementById('root'));

serviceWorkerRegistration.register({
  onUpdate: reg => {
    try {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('error', error);
    }
  },
});
